import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/servicios-qms-psmf")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/servicios-qms-psmf", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/servicios-qms-psmf", replace: true });
  },
});
